<template>
    <div class="interface-help">
        <h2>Браузер</h2>
        <p>
            В этом задании Вам придется работать с имитацией интернет-браузера.
        </p>
        <p>
            Присутствует возможность переходить по гиперссылкам. При наведении на гиперссылку в браузере меняется внешний вид курсора.<br> 
            <img class="interface-help__image interface-help__image--1" src="/images/help/browser-link.jpg" alt="">
        </p>
        <p>
            При нажатии ссылка открывается в новой вкладке браузера. Открытые вкладки, расположены в верхней части браузера. Открытая (активная) вкладка, выделена более темным цветом и выделяется синим цветом. Есть возможность перехода между доступными вкладками. Все открытые вкладки можно закрыть.<br>
            <img class="interface-help__image interface-help__image--2" src="/images/help/browser-tabs.jpg" alt="">
        </p>
        <p>
            Общий вид браузера<br>
            <img class="interface-help__image" src="/images/help/browser.jpg" alt="">
        </p>
    </div>
</template>
<script>
    export default {}
</script>
<style lang="stylus" scoped>
    .interface-help {
        p {
            max-width 80%
        }

        &__image {
            max-width 60%
            border 1px solid rgba(0, 0, 0, .4)

            &--1 {
                max-width 224px
            }

            &--2 {
                max-width 336px
            }
        }
    }
</style>